<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="Dedication-ded"><span class="ePub-I">For Holly West, without whom this book,</span></p>
<p class="Dedication-ded"><span class="ePub-I">and so many others, would not exist.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a813d658